export default {
  loadFailed: 'Failed to load DPI',
  gear: {
    title: 'DPI Gear',
    cancelSelection: 'Cancel Selection',
    deleteDialog: {
      title: 'Delete DPI Gear',
      content:
        'Confirm deletion of this DPI setting. Once deleted, it cannot be restored and must be re-added.',
    },
    cancel: 'Cancel',
    delete: 'Delete',
  },
  slider: {
    title: 'DPI Settings',
    independentXY: 'Independent X-axis and Y-axis settings',
  },
}
